import { BrandsAndProductsResponse } from '@api/api/theme-overview';
import { useQuery } from '@tanstack/react-query';
import { getBrandsAndProducts } from '@terminal/services/overview-widget/overview-widget-service';
import { WretchError } from 'wretch/types';

export const QUERY_KEY_BRANDS_AND_PRODUCTS = 'QUERY_KEY_BRANDS_AND_PRODUCTS';

export const useBrandsAndProducts = (entityTag: string, enabled = true) => {
  return useQuery<BrandsAndProductsResponse, WretchError>({
    queryKey: [QUERY_KEY_BRANDS_AND_PRODUCTS, entityTag],
    queryFn: ({ signal }) => getBrandsAndProducts({ entityTag, signal }),
    enabled,
  });
};
